module.exports = __webpack_public_path__ + "img/last_greetings.b95aff0e.png";